module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-9@2x.80e26c8c.png";